import { get, post, patch, del } from './client.js';
const base = (wsId) => `/workspaces/${wsId}/approvals`;
export const listRules     = (wsId)            => get(`${base(wsId)}/rules`);
export const createRule    = (wsId, dto)       => post(`${base(wsId)}/rules`, dto);
export const updateRule    = (wsId, id, dto)   => patch(`${base(wsId)}/rules/${id}`, dto);
export const deleteRule    = (wsId, id)        => del(`${base(wsId)}/rules/${id}`);
export const listRequests  = (wsId)            => get(`${base(wsId)}/requests`);
export const createRequest = (wsId, dto)       => post(`${base(wsId)}/requests`, dto);
export const vote          = (wsId, id, dto)   => post(`${base(wsId)}/requests/${id}/vote`, dto);
